<template>
    <v-flex>
        <upcoming-event v-if="canViewEvents" />
        <v-flex xs12 v-if="isVisible">
            <related-networks
                class="panelBlock"
                v-if="!isAllNetworks && canViewRelatedCommunities"
                :can-view-sub-networks="!isSubNetwork"></related-networks>
            <community-officers-list class="panelBlock" v-if="!isAllNetworks"></community-officers-list>
        </v-flex>
    </v-flex>
</template>

<script>
    import CommunityOfficersList from '../CommunityOfficersList/CommunityOfficersList';
    import UpcomingEvent from '@/components/ChapterPage/UpcomingEvents/UpcomingEvent';
    import { storeGetters } from '@/store/storeGetters.constant';
    import { upcomingEventsConstant } from '@/components/ChapterPage/communityCommon.constant';
    import RelatedNetworks from './RelatedNetworks.vue';
    import { mapGetters, mapActions } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import { myToolsConstants } from '../Tools/mytools.constant';

    export default {
        name: "NetworkRightSidebar",
        components: {
            CommunityOfficersList,
            UpcomingEvent,
            RelatedNetworks,
        },
        data() {
            return {
                dialogState: {
                    isVisible: false,
                },
                hasOfficers: false,
                upcomingEventsConstant,
            };
        },
        computed: {
            ...mapGetters({
                ypoNetworks: `network/${[storeGetters.ypoNetworks]}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            ...mapActions({
                getSubNetworksList: `network/${storeAction.getSubNetworksData}`,
            }),
            isVisible() {
                return this.$route.params.communityId && this.usersCommunitiesList;
            },
            viewAllMembers() {
                return (this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId)) ||
                    (this.communityInfo && this.communityInfo.isAdmin) || (this.communityInfo && this.communityInfo.category.toLowerCase() === "public");
            },
            canViewEvents() {
                return this.communityInfo && this.communityInfo.communityId === this.$route.params.communityId && this.communityInfo.userAccess && this.communityInfo.userAccess.canViewEvents;
            },
            canViewRelatedCommunities() {
                return this.communityInfo && this.communityInfo.communityId === this.$route.params.communityId && (this.communityInfo.isAdmin || this.communityInfo.isMember || (this.communityInfo.userAccess && this.communityInfo.userAccess.canViewRelatedCommunities));
            },
            isSubNetwork() {
                //!checking if current item exists in YpoNetworks if not that will be a subNetwork
                return this.ypoNetworks && !this.ypoNetworks.some(o => o.communityId === this.$route.params.communityId);
            },
            isAllNetworks() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .time_block {
        margin: 20px 10px 10px 10px;
        padding: 10px 5px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0 rgba($black, 0.18);
        border: 1px solid rgba($ypo-gray, 0.4);

        .date {
            color: $ypo-dark-background-gray;
            line-height: 12px;
            padding-left: 5px;

            span {
                font-size: 12px;
                display: block;
                font-weight: 600;
                line-height: normal;
            }

            strong {
                color: $ypo_blue;
                font-family: "Noto Sans";
                font-size: 28px;
                display: block;
                line-height: normal;
                padding: 4px 0;
                font-weight: 400;
            }

            small {
                color: $ypo-dark-background-gray;
                font-size: 10px;
                font-weight: bold;
            }
        }

        .desc {
            color: $ypo_blue;
            font-family: "Noto Sans";
            font-size: 12px;
            font-weight: bold;
            letter-spacing: -0.15px;
            line-height: 17px;
            margin-bottom: 30px;
        }

        .v-avatar {
            border: 1px solid $ypo-medium-gray;
        }

        .member__deatils {
            span {
                color: $ypo-dark-background-gray;
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 15px;
                padding-left: 5px;
            }

            .v-btn {
                width: auto;
                height: auto;
                color: $ypo-dark-background-gray;
                font-size: 12px;
                letter-spacing: 0.4px;
                line-height: 16px;
                text-align: right;

                &:hover {
                    &:before {
                        background-color: transparent;
                    }

                    &:active {
                        background-color: transparent;
                    }
                }

                &:focus {
                    background-color: transparent;
                }
            }
        }

        .action-btns {
            border-top: 1px solid $ypo-medium-gray;
            margin-top: 10px;
            padding-top: 5px;
            text-align: center;

            .v-btn {
                padding: 0;
                text-transform: capitalize;
                min-width: auto;
                background: transparent !important;
                box-shadow: none !important;
                height: auto;
                color: $ypo-dark-background-gray;
                font-size: 12px;
                margin: 0;

                &.active {
                    color: $ypo-green;

                    i {
                        color: $ypo-green;
                        margin-top: 0;
                        font-size: 14px;
                        margin-right: 3px;
                    }
                }

                &:hover {
                    &:before {
                        background-color: transparent;
                    }

                    &:active {
                        background-color: transparent;
                    }
                }

                &:focus {
                    background-color: transparent;
                }
            }

            i {
                font-size: 20px;
                color: $ypo-cta;
                margin-top: 5px;
                cursor: pointer;
            }
        }
    }

    .rec_events {
        .v-card {
            margin: 10px;
            border: 1px solid rgba($ypo-gray, 0.2);
            border-radius: 4px;
            background-color: rgba($ypo-gray, 0.1);
            box-shadow: none;
            min-height: 230px;
            font-size: 12px;

            span {
                color: $ypo-blue;
            }

            .headline {
                color: $white;
                position: relative;
                font-size: 16px !important;
                left: 10px;
                top: 5px;
            }
        }

        .image-overlay {
            &:before {
                background: linear-gradient(0deg, rgba($black, 0) 0%, $black 100%);
                content: "";
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                position: absolute;
            }
        }

        .fill-height {
            padding: 0;

            .v-icon {
                font-size: 14px;
                color: $white;
                position: absolute;
                right: 5px;
                top: 5px;
                cursor: pointer;
                opacity: 0.3;
            }
        }

        .v-card__title {
            min-height: 100px;
            align-items: flex-start;
        }
    }
</style>
